<div aria-live="polite">
	@if (showLoadingSpinner()) {
		<div class="ao-align-center" @fadeInOut>
			<p class="sr-only">Claim found. Claim details loading.</p>
			<span class="ao-spinner-128"></span>
		</div>
	}
</div>

@if (showClaimDetails()) {
	<div claimTrackerIdleTracking class="flexbox" @expandCollapse>
		<div class="left-panel">
			<section>
				<h1 class="ao-heading-100 ao-bottom-32" tabindex="-1">Claim #{{ claim.claimNumber }}</h1>
				<p>Date of Loss: {{ claim.lossDate | date: 'MM/dd/yyyy' }}</p>
			</section>
			<section class="ao-top-64">
				<claim-tracker-claim-activity [claim]="claim"></claim-tracker-claim-activity>
			</section>
		</div>
		<section class="ao-featurebox right-panel">
			<claim-tracker-claim-reps [claim]="claim"></claim-tracker-claim-reps>
		</section>
	</div>
}
